module.exports = __webpack_public_path__ + "img/americano.24853d65.svg";